/**
 * Create Product Use Case
 *
 * Business logic for creating a new product following clean architecture principles.
 * Handles form data validation, transformation, and product creation.
 *
 * @module CreateProductUseCase
 */

import {ProductRepository} from '../repository/ProductRepository';
import {Product} from '../models/product.model';

export class CreateProductUseCase {
  constructor (private productRepository: ProductRepository) {}

  /**
   * Execute product creation
   * @param formData - FormData for API submission
   * @returns Promise<Product> - Created product
   */
  async execute (formData: FormData): Promise<Product> {
    // Create product through repository
    const product = await this.productRepository.createProduct(formData);

    return product;
  }

}
